import { EventBus } from "../events";
import { getGAIDFromCookie } from "../helpers/utils";

const lemniskSrcId = 6;

export const HOSTS = {
  SHELL_APP: "SHELL_APP",
  BROWSER: "BROWSER",
};

function lemniskPageEvent(data) {
  data.srcid = lemniskSrcId;
  lmSMTObj.page(data);
  return;
}

function getEventConfig() {
  return window.env.EVENT_CONFIG;
}

function setupRudderStack() {
  window.rudderanalytics = [];
  let eventConfig = getEventConfig();
  let rudderStackConfig = eventConfig && eventConfig.rudderstack;
  if (rudderStackConfig && rudderStackConfig.enabled) {
    var methods = ["load", "page", "track", "identify"];

    for (var i = 0; i < methods.length; i++) {
      var method = methods[i];
      window.rudderanalytics[method] = (function (methodName) {
        return function () {
          window.rudderanalytics.push(
            [methodName].concat(Array.prototype.slice.call(arguments))
          );
        };
      })(method);
    }

    rudderanalytics.load(
      rudderStackConfig.writekey,
      rudderStackConfig.planeUrl
    );
    rudderanalytics.page();
  }
}

function analyticsTrackEvent(
  eventName,
  data = {},
  eventCallBack = null,
  identifyEventObj = null
) {
  let eventConfig = getEventConfig();
  let rudderStackConfig = eventConfig && eventConfig.rudderstack;
  let lemniskConfig = eventConfig && eventConfig.lemnisk;
  let webengageConfig = eventConfig && eventConfig.webengage;
  let lemniskEnable = lemniskConfig && lemniskConfig.enabled;
  let rudderStackEnabled = rudderStackConfig && rudderStackConfig.enabled;
  let webengageEnabled = webengageConfig && webengageConfig.enabled;
  data.srcid = lemniskSrcId;
  //send normal track event to lemnisk if there is no identifyEventObj
  //otherwise call the track event first without any callback and then send identify Event with the callback
  //identify event is passed in case of accounts_lead-form:otp_verified and accounts_login:otp_verified events
  if (!identifyEventObj) {
    lemniskEnable && lmSMTObj.track(eventName, data, null, eventCallBack);
    rudderStackEnabled &&
      window.rudderanalytics.track(eventName, data, null, eventCallBack);
    webengageEnabled && webengage.track(eventName, data);
  } else {
    let { customerId, ...traits } = identifyEventObj;
    const clonedTraits = { ...traits };
    lemniskEnable &&
      lmSMTObj.track(
        eventName,
        data,
        null,
        lemniskEnable &&
          lemniskIdentifyEvent.bind(null, customerId, traits, {}, eventCallBack)
      );
    rudderStackEnabled &&
      window.rudderanalytics.identify(customerId, traits, {});

    if (webengageEnabled) {
      webengage.user.login(clonedTraits.email);
      webengage.user.setAttribute("we_first_name", clonedTraits.name);
      webengage.user.setAttribute("we_email", clonedTraits.email);
      webengage.user.setAttribute("we_phone", clonedTraits.phone);

    }
  }
  return;
}

function lemniskIdentifyEvent(
  customerId,
  traits = {},
  options = {},
  callback = null
) {
  options = { ...options, srcid: lemniskSrcId };
  lmSMTObj.identify("CX" + customerId, traits, options, callback);
  return;
}

function disableLemnisk() {
  if (process.env.NODE_ENV !== "production") {
    return true;
  }
  return false;
}

const trackEventHandlerMap = {
  [HOSTS.SHELL_APP]: forwardEventToShellApp,
  [HOSTS.BROWSER]: analyticsTrackEvent,
};

export default {
  install: function (Vue, router) {
    setupRudderStack();
    let eventConfig = window.env.EVENT_CONFIG;
    let rudderStackConfig = eventConfig && eventConfig.rudderstack;
    let lemniskConfig = eventConfig && eventConfig.lemnisk;
    let lemniskEnable = lemniskConfig && lemniskConfig.enabled;
    let rudderStackEnable = rudderStackConfig && rudderStackConfig.enabled;
    /*
     ** Only run on client-side and only in production mode
     */
    // if (disableLemnisk()) return;

    //Below code stores lemnisk calls even if the lemnisk single tag is not downloaded
    //later lemnisk uses command queue pattern to trigger calls. This prevents data loss
    window.lmSMTObj = window.lmSMTObj || [];
    if (!Object.keys(window.lmSMTObj).length) {
      var methods = ["init", "page", "track", "identify"];
      for (var i = 0; i < methods.length; i++) {
        lmSMTObj[methods[i]] = (function (methodName) {
          return function () {
            lmSMTObj.push(
              [methodName].concat(Array.prototype.slice.call(arguments))
            );
          };
        })(methods[i]);
      }
    }

    /*
     ** Set the current page
     ** Every time the route changes (fired on initialization too)
     */
    router.afterEach((to, from) => {
      Vue.nextTick(() => {
        let data = {
          path: window.location.href,
          referrer: document.referrer,
          pageUrl: window.parent.location.href,
        };
        lemniskEnable && lemniskPageEvent(data);
        rudderStackEnable && window.rudderanalytics.page(data);
      });
    });
    EventBus.$on("captureEvents", handleAnalyticsCall);
    EventBus.$on("captureGAEvent", handleAnalyticsCallForGA);
  },
};

function handleAnalyticsCall(
  eventName,
  data = {},
  eventCallBack = null,
  identifyEventObj = null
) {
  trackEventHandlerMap[getHost()].call(
    this,
    eventName,
    data,
    eventCallBack,
    identifyEventObj
  );
}

function handleAnalyticsCallForGA(
  eventName,
  eventData = {}
) {
  const defaultData = {
    client_id: getGAIDFromCookie() || 'NA',
    user_status: 'guest',
    page_type: 'sign_up_page'
  }
  trackEventHandlerMap[getHost()].call(
    this,
    eventName,
    { ...defaultData, ...eventData },
  );
}

/**
 * @returns the host.
 */
export function getHost() {
  return window.navigator.userAgent.includes(window.env.SHELL_APP_USERAGENT)
    ? HOSTS.SHELL_APP
    : HOSTS.BROWSER;
}

/**
 * @param {string} eventName : the name of the event
 * @param {any} eventData : payload for the event
 */
function forwardEventToShellApp(eventName, eventData = {}) {
  if (!eventName) return;
  const msg = {
    // identifier to let the host know that this post message is not
    // the default one it generally gets on navigation state change
    isMessageFromWebContext: true,
    // send this event from the host's CleverTap SDK
    actionType: "CLEVERTAP_EVENT",
    // CleverTap event name
    ct_event_name: eventName,
    // CleverTap event payload
    ct_event_payload: eventData,
  };
  window.ReactNativeWebView.postMessage(JSON.stringify(msg));
}
